export default {
  tipsOne:
    "1. Nous conserverons les marchandises gratuitement pendant 90 jours. Si vous ne soumettez pas le colis ou n'effectuez aucune action après 90 jours, cela sera considéré comme un abandon des marchandises, et nous les détruirons uniformément.",
  tipsTwo:
    "2. Les marchandises ont été mises en entrepôt, vous pouvez accéder à mon entrepôt à tout moment et soumettre votre adresse de livraison à l'étranger",
  orderDetail: 'Détail de la commande',
  orderNo: 'N° de commande',
  orderConsult: 'Consultation de commande',
  consult: 'Demande',
  orderConsultTips:
    "L'agent d'achat ne peut traiter que les affaires liées à cette commande. Pour toute autre demande, veuillez contacter",
  enquiryReplyMsg:
    'Saisissez ici, nous vous répondrons dans les 24 heures. (Remarque : Il se peut que nous utilisions un logiciel de traduction pour répondre, ce qui pourrait ne pas transmettre fidèlement le sens, nous espérons votre compréhension)',
  stepListEnum: {
    '-1': 'Sélectionner les produits',
    0: 'Soumettre le colis',
    6: 'Payer le fret',
    9: 'Envoyer le colis',
    20: 'Confirmer la réception',
  },
}
